import { SearchParams } from "../../commons/abstract.types";
import { Pager } from "../../commons/pager";

export interface ListState<T> {
  pager?: Pager<T>;
  search?: string;
  params?: Partial<SearchParams>,
  extraData?: Record<string, string | number | object>,
  lists?: Record<string, Array<unknown>>
}

export enum CacheKeyEnum {
  USER_LIST = 'USER_LIST',
  COMPANY_LIST = 'COMPANY_LIST',
  CONTACT_LIST = 'CONTACT_LIST',
  ATTENDANCE_LIST = 'ATTENDANCE_LIST',
  TRACKER_LIST = 'TRACKER_LIST',
  QUICK_RESPONSES_LIST = 'QUICK_RESPONSES_LIST',
  WARNING_WORDS = 'WARNING_WORDS',
  CATEGORIES_LIST = 'CATEGORIES_LIST',
  TAGS_LIST = 'TAGS_LIST',
  CUSTOM_FILDS_LIST = 'CUSTOM_FILDS_LIST',
  TABULATIONS_LIST = 'TABULATIONS_LIST',
  LEADS_SOURCES_LIST = 'LEADS_SOURCES_LIST',
  CAMPAIGN_LIST = 'CAMPAIGN_LIST',
  CRM_FILTERS = 'CRM_FILTERS',
  WALLET_LEDGER_LIST = 'WALLET_LEDGER_LIST'
}

